import React, { useEffect, useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { levelList } from '../../constants';
import ButtonSpiner from '../buttonSpinner';

const SaveButton = ({
  saveKata,
  runDisabled,
  isSaving,
  value,
  tests,
  question,
  title,
  publishedAndLevel,
}) => {
  const [canSave, setCanSave] = useState(false);
  const [level, setLevel] = useState('');
  const [isPublished, setIsPublished] = useState('1');

  useEffect(() => {
    setCanSave(tests.length > 0 && question && value && level && title);
  }, [tests, value, level, title, question]);
  useEffect(() => {
    if (publishedAndLevel) {
      setIsPublished(publishedAndLevel.isPublished ? '1' : '');
      setLevel(String(publishedAndLevel.level));
    }
  }, [publishedAndLevel]);

  const onChangeLevel = e => {
    setLevel(e.target.value);
  };
  const onChangePublish = e => {
    setIsPublished(e.target.value);
  };

  return (
    <>
      <Form.Select className="level-list" onChange={onChangePublish} value={isPublished}>
        <option value="1">Publish</option>
        <option value="">Draft</option>
      </Form.Select>
      <Form.Select className="level-list" onChange={onChangeLevel} value={level}>
        <option value="">Level</option>
        {levelList.map((level, index) => (
          <option key={index} value={level.value}>
            {level.label}
          </option>
        ))}
      </Form.Select>
      <Button
        className="save-btn"
        variant="primary"
        onClick={() => {
          if (publishedAndLevel) {
            saveKata({ isPublished: Boolean(isPublished), level }, false);
            return;
          }
          saveKata({ isPublished: Boolean(isPublished), level });
        }}
        disabled={runDisabled || !canSave}
      >
        {isSaving ? (
          <>
            <ButtonSpiner />
            {!publishedAndLevel ? 'Saving...' : 'Updating...'}
          </>
        ) : !publishedAndLevel ? (
          'Save'
        ) : (
          'Update'
        )}
      </Button>
    </>
  );
};

export default SaveButton;
